import { Room } from '@spike/room-model';

type RoomAreas = Pick<Room, 'daycareEnabled' | 'boardingEnabled'>;

export const getRoomAreaLabel = (room: RoomAreas): string => {
    if (room.daycareEnabled && room.boardingEnabled) {
        return 'Daycare & Boarding';
    }
    if (room.daycareEnabled) {
        return 'Daycare';
    }
    if (room.boardingEnabled) {
        return 'Boarding';
    }
    return '';
};

// Daycare-enabled rooms (shared ones included) first, then Boarding-only, A–Z within each group.
export const compareDaycareFirst = (a: RoomAreas & Pick<Room, 'name'>, b: RoomAreas & Pick<Room, 'name'>): number => {
    if (a.daycareEnabled !== b.daycareEnabled) {
        return a.daycareEnabled ? -1 : 1;
    }
    return a.name.localeCompare(b.name);
};
